import { BindingError } from "../../BindingError.js";
import { PRIMARY_KEY_NAME } from "../../bindingTypes.js";
import { EventManager } from "../EventManager.js";
import { RealmKeyGenerator } from "../RealmKeyGenerator.js";
class OperationsHelpers {
  static rejectInvalidAccessorTree() {
    throw new BindingError(
      `The accessor tree does not correspond to the MarkerTree. This should absolutely never happen.`
    );
  }
  static resolveAndPrepareEntityToConnect(treeStore, entityToConnect) {
    const entityToConnectKey = entityToConnect.key;
    const stateToConnect = treeStore.entityRealmStore.get(entityToConnectKey);
    if (stateToConnect === void 0) {
      throw new BindingError(`Attempting to connect an entity with key '${entityToConnectKey}' but it doesn't exist.`);
    }
    return stateToConnect;
  }
  static changeEntityId(treeStore, eventManager, stateInitializer, entity, newId) {
    const previousId = entity.id;
    treeStore.entityStore.delete(previousId.uniqueValue);
    treeStore.entityStore.set(newId.uniqueValue, entity);
    let counter = 0;
    for (const realm of entity.realms.values()) {
      this.changeRealmId(treeStore, eventManager, stateInitializer, realm, newId);
      if (++counter === entity.realms.size) {
        break;
      }
    }
    entity.hasIdSetInStone = true;
    entity.id = newId;
  }
  static changeRealmId(treeStore, eventManager, stateInitializer, realm, newId) {
    const oldEntity = realm.entity;
    const oldRealmKey = realm.realmKey;
    const oldId = oldEntity.id;
    const realmBlueprint = realm.blueprint;
    const newEntity = stateInitializer.initializeEntityState(newId, oldEntity.entityName);
    const newRealmKey = RealmKeyGenerator.getRealmKey(newId, realmBlueprint);
    realm.realmKey = newRealmKey;
    realm.entity = newEntity;
    newEntity.id = newId;
    oldEntity.realms.delete(oldRealmKey);
    newEntity.realms.set(newRealmKey, realm);
    if (realm.type === "entityRealm") {
      const childIdState = realm.children.get(PRIMARY_KEY_NAME);
      if (childIdState?.type === "field") {
        childIdState.value = newId.value;
        eventManager.registerJustUpdated(childIdState, EventManager.NO_CHANGES_DIFFERENCE);
      }
      this.purgeStaleListenersAfterIdChange(realm);
    }
    if (oldEntity.realms.size === 0) {
      treeStore.disposeOfEntity(oldEntity);
    }
    treeStore.entityRealmStore.delete(oldRealmKey);
    treeStore.entityRealmStore.set(newRealmKey, realm);
    if (realmBlueprint.type === "listEntity") {
      const list = realmBlueprint.parent;
      list.children.changeKey(oldId.value, newId.value);
    } else if (realmBlueprint.type === "hasOne") {
      eventManager.registerUpdatedConnection(realmBlueprint.parent, realmBlueprint.marker.placeholderName);
    }
    const parent = realmBlueprint.parent;
    if (parent) {
      eventManager.registerJustUpdated(parent, EventManager.NO_CHANGES_DIFFERENCE);
    }
    if (realm.type === "entityRealm") {
      eventManager.registerJustUpdated(realm, EventManager.NO_CHANGES_DIFFERENCE);
    }
  }
  static purgeStaleListenersAfterIdChange(realm) {
    const listeners = realm.eventListeners;
    if (listeners) {
      if (realm.blueprint.parent) {
        listeners.delete({ type: "update" });
      }
      listeners.deleteByType("connectionUpdate");
    }
  }
}
export {
  OperationsHelpers
};
//# sourceMappingURL=OperationsHelpers.js.map
